angular.module('NumbersEditor').
    factory('AuthInterceptorFactory', [
        '$q', '$location', function ($q, $location) {

            var authInterceptorServiceFactory = {};

            authInterceptorServiceFactory.request = function (config) {
                config.headers = config.headers || {};
                var authData = localStorage.getItem("authorizationData");

                localStorage.setItem("activity", (new Date()).toISOString());
                
                if (authData != null) {
                    config.headers.Authorization = 'Bearer ' + JSON.parse(authData).token;
                } else {
                    window.location.assign('login.html');
                }

                return config;
            }

            authInterceptorServiceFactory.responseError = function (rejection) {
                if (rejection.status === 401) {
                    localStorage.removeItem("authorizationData");
                    localStorage.removeItem("authenticationData");
                    localStorage.removeItem("authenticationRefreshData");
                    localStorage.removeItem("activity");
                    localStorage.removeItem("homeFilterData");
                    //$location.path('/login');
                    window.location = "/login.html";
                    return;
                }
                
                return $q.reject(rejection);
            }

            return authInterceptorServiceFactory;
        }
    ]);